import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const LimiteCreditoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='LÍMITE CRÉDITO' htmlFor='select-limiteCredito' md={3} />
      <Col md={9}>
        <Field name='limiteCredito'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-limiteCredito'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(LimiteCreditoFormGroup)
